import { useBuyerGlobalSocketHandler } from 'services/socket/handleBuyerEvents';
import { useMyBidsSocketEffect } from 'services/socket/handleMyBidsEvent';
import { useMySalesSocketEffect } from '../../services/socket/handleSaleEvents';
import { useSellerGlobalSocketHandler } from 'services/socket/handleSellerUserEvents';
import { useAdminGlobalSocketHandler } from 'services/socket/handleAdminUserEvents';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import getSocket, { reconnectWithToken } from 'services/socket';
import { getToken } from 'utils/auth';

export default function GlobalSocketProvider() {
  const user = useSelector((state: any) => state.user.user);

  useEffect(() => {
    reconnectWithToken(getToken());
  }, [user?.id]);

  useEffect(() => {
    const socket = getSocket();
    const handleSubscribeError = ({ channel, reason }: { channel: string; reason: string }) => {
      console.warn(`WebSocket subscription rejected: ${channel} — ${reason}`);
    };
    socket.on('subscribe-error', handleSubscribeError);
    return () => {
      socket.off('subscribe-error', handleSubscribeError);
    };
  }, []);
  if (user?.role === 'buyer') {
    return <BuyerSocketProvider />;
  }

  if (user?.role === 'seller') {
    return <SellerSocketProvider />;
  }

  if (user?.role === 'admin') {
    return <AdminSocketProvider />;
  }

  return null;
}

const BuyerSocketProvider = () => {
  useBuyerGlobalSocketHandler();
  useMyBidsSocketEffect();

  return null;
};

const SellerSocketProvider = () => {
  useSellerGlobalSocketHandler();
  useMySalesSocketEffect();

  return null;
};

const AdminSocketProvider = () => {
  useAdminGlobalSocketHandler();

  return null;
};
